module.exports = __webpack_public_path__ + "img/main9.e6b428a9.jpg";